import React from 'react';

interface MenuItem {
  icon: string;
  label: string;
  active?: boolean;
}

interface TestMenuProps {
  items?: MenuItem[];
}

const TestMenu: React.FC<TestMenuProps> = ({ items }) => {
  const defaultItems: MenuItem[] = [
    { icon: '🏠', label: 'Dashboard' },
    { icon: '📊', label: 'Reports' },
    { icon: '📋', label: 'Tasks', active: true },
    { icon: '👥', label: 'Users' },
    { icon: '⚙️', label: 'Settings' }
  ];

  const menuItems = items || defaultItems;

  return (
    <div className="layout-flex-col" style={{ 
      gap: '8px', 
      padding: '16px 8px',
      height: '100%' 
    }}>
      {menuItems.map((item, index) => (
        <button 
          key={item.label}
          className={`btn-icon-menu ${item.active ? 'active' : ''}`}
          title={item.label}
          style={{
            background: item.active ? 'rgba(255,255,255,0.2)' : 'transparent',
            border: 'none',
            color: 'white',
            padding: '8px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '18px'
          }}
        >
          {item.icon}
        </button>
      ))}
    </div>
  );
};

export default TestMenu;